import { governedNavEnabled } from "../../app/governedNav.js";

/**
 * Report surfaces use live readiness and Projects/Offices governance from the
 * app shell. Market report content is not governed by the Markets nav item:
 * that item controls navigation visibility only.
 */
export function getReportNavEligibility(context = {}, currentRole) {
  const flags = context.flags;
  const navConfig = context.nav_config ?? context.navConfig;
  const navOrder = context.nav_order ?? context.navOrder;
  const hasGovernance = navConfig || navOrder || (flags && Object.keys(flags).length > 0);
  const dataCoverage = context.flagsReady === true
    && context.reportAccess?.["report-data-coverage"] === true
    && (currentRole === "admin" || currentRole === "editor")
    && (!hasGovernance || governedNavEnabled(flags, navConfig, "reports", navOrder));
  // Older isolated report tests and embedders provide no governance payload at
  // all. The live FeatureFlagContext always supplies config/order, so only that
  // legacy absent-context shape gets the permissive compatibility default.
  if (!navConfig && !navOrder && (!flags || Object.keys(flags).length === 0)) {
    return { ready: true, projects: true, offices: true, markets: true, dataCoverage };
  }
  const ready = context.flagsReady !== false;
  return {
    ready,
    dataCoverage,
    projects: ready && governedNavEnabled(flags, navConfig, "projects", navOrder),
    offices: ready && governedNavEnabled(flags, navConfig, "portfolio", navOrder),
    markets: ready,
  };
}

export function getAvailableReportKeys(reportKeys, eligibility) {
  return reportKeys.filter((key) => {
    if (key === "report-data-coverage") return eligibility.ready && eligibility.dataCoverage === true;
    if (key === "report-wpr") return eligibility.ready && (eligibility.projects || eligibility.offices);
    if (["report-space-fit", "report-foot-traffic", "report-utilization"].includes(key)) {
      return eligibility.ready && eligibility.offices;
    }
    return true;
  });
}